import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Gavel, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';

// Animation component for text appearing line by line
const AnimatedParagraph = ({ children, delay = 0 }: { children: React.ReactNode; delay?: number }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <p
      className={`text-lg text-muted-foreground mb-6 leading-relaxed text-justify transition-all duration-1000 ease-out ${
        isVisible
          ? 'opacity-100 transform translate-y-0'
          : 'opacity-0 transform translate-y-4'
      }`}
    >
      {children}
    </p>
  );
};

const AttorneyInFactPage = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <section className="pt-32 pb-20 bg-background">
        <div className="max-w-4xl mx-auto px-4">
          <div className="text-center mb-12">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-gold/10 rounded-full mb-6">
              <Gavel className="h-8 w-8 text-gold-light" />
            </div>
            <h1 className="font-rockwell text-4xl md:text-5xl font-semibold text-primary mb-6">
              Attorney-in-Fact
            </h1>
            <p className="text-xl text-muted-foreground leading-relaxed">
              Legal guidance and dispute resolution via litigation in federal court
            </p>
          </div>

          <div className="prose prose-lg max-w-none">
            <AnimatedParagraph delay={200}>
              Our Attorney-in-Fact services provide comprehensive legal representation and guidance for those seeking to navigate the federal court system while maintaining their sovereign status and constitutional rights.
            </AnimatedParagraph>
            
            <AnimatedParagraph delay={600}>
              This service includes dispute resolution, litigation support, and legal consultation to ensure your rights are protected throughout any legal proceedings.
            </AnimatedParagraph>

            <div className="mt-12 p-8 bg-primary/5 rounded-lg border border-primary/10">
              <h3 className="font-rockwell text-2xl font-semibold text-primary mb-4">
                Ready to Get Started?
              </h3>
              <p className="text-muted-foreground mb-6">
                Contact us to learn more about our Attorney-in-Fact services and how we can help protect your rights.
              </p>
              <div className="flex flex-col gap-4 items-start">
                <Button asChild className="bg-primary hover:bg-primary/90 text-primary-foreground">
                  <Link to="/work-with-us" className="flex items-center gap-2">
                    Work with Us
                    <ArrowRight className="h-5 w-5" />
                  </Link>
                </Button>
                <Button asChild variant="outline">
                  <Link to="/education" className="flex items-center gap-2">
                    Do It Yourself
                    <ArrowRight className="h-5 w-5" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default AttorneyInFactPage;